export default __webpack_public_path__ + "static/figure-gallery-4-reference-5a3bc16e13199b39af93dd3a4576c6b7.jpg";